import React, { useState, useEffect } from 'react';
import api from '../../../config/axios';
import Swal from 'sweetalert2';
import { FaRegSave, FaTimes, FaPlus, FaTrash } from 'react-icons/fa';

const OndeConheceuModal = ({ onClose }) => {
    const [opcoes, setOpcoes] = useState([{ id: null, valor: '', isNew: true }]);
    const [opcoesOriginais, setOpcoesOriginais] = useState([]);

    useEffect(() => {
        fetchOpcoes();
    }, []);

    const fetchOpcoes = async () => {
        try {
            Swal.fire({
                title: "Carregando...",
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const response = await api.get('/configuracoes-onde-conheceu');
            if (response.data && response.data.length > 0) {
                const opcoesExistentes = response.data.map(item => ({
                    id: item.id,
                    valor: item.valor,
                    isNew: false
                }));
                setOpcoes(opcoesExistentes);
                setOpcoesOriginais(JSON.parse(JSON.stringify(opcoesExistentes)));
            } else {
                setOpcoes([{ id: null, valor: '', isNew: true }]);
                setOpcoesOriginais([]);
            }
            Swal.close();
        } catch (error) {
            setOpcoes([{ id: null, valor: '', isNew: true }]);
            setOpcoesOriginais([]);
            Swal.close();
        }
    };

    const handleChange = (index, value) => {
        const novasOpcoes = [...opcoes];
        novasOpcoes[index].valor = value;
        setOpcoes(novasOpcoes);
    };

    const handleAdicionarOpcao = () => {
        setOpcoes([...opcoes, { id: null, valor: '', isNew: true }]);
    };

    const handleRemoverOpcao = async (index) => {
        const opcao = opcoes[index];

        if (opcao.isNew) {
            const novasOpcoes = opcoes.filter((_, i) => i !== index);
            setOpcoes(novasOpcoes);
            return;
        }

        try {
            const result = await Swal.fire({
                title: 'Confirmar Exclusão',
                text: `Deseja excluir a opção "${opcao.valor}"?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim, excluir!',
                cancelButtonText: 'Cancelar'
            });

            if (!result.isConfirmed) {
                return;
            }

            const validacaoResponse = await api.get(`/configuracoes-onde-conheceu/${opcao.id}/validacao-exclusao`);
            const quantidadeClientes = validacaoResponse.data.quantidade_clientes || 0;

            if (quantidadeClientes > 0) {
                Swal.fire(
                    'Não é possível excluir',
                    `Esta opção não pode ser excluída porque existem ${quantidadeClientes} cliente(s) cadastrado(s) com esta opção.`,
                    'error'
                );
                return;
            }

            Swal.fire({
                title: "Carregando...",
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            await api.delete(`/configuracoes-onde-conheceu/${opcao.id}`);

            const novasOpcoes = opcoes.filter((_, i) => i !== index);
            setOpcoes(novasOpcoes);

            Swal.fire('Excluído!', 'Opção foi excluída com sucesso.', 'success');
        } catch (error) {
            Swal.close();
            const mensagem = error.response?.data?.message || 'Erro ao excluir opção. Tente novamente.';
            Swal.fire('Erro', mensagem, 'error');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const opcoesValidas = opcoes.filter(opcao => opcao.valor.trim() !== '');

        if (opcoesValidas.length === 0) {
            Swal.fire('Erro', 'Adicione pelo menos uma opção válida', 'error');
            return;
        }

        try {
            Swal.fire({
                title: "Carregando...",
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const opcoesNovas = opcoesValidas.filter(opcao => opcao.isNew);
            const opcoesAlteradas = opcoesValidas.filter(opcao => {
                if (opcao.isNew) return false;
                const original = opcoesOriginais.find(orig => orig.id === opcao.id);
                if (!original) return false;

                const valorAtual = opcao.valor.trim();
                const valorOriginal = original.valor.trim();

                return valorOriginal !== valorAtual;
            });

            if (opcoesNovas.length > 0) {
                const valoresNovos = opcoesNovas.map(opcao => ({ valor: opcao.valor }));
                await api.post('/configuracoes-onde-conheceu', valoresNovos);
            }

            if (opcoesAlteradas.length > 0) {
                const valoresAlterados = opcoesAlteradas.map(opcao => ({
                    id: opcao.id,
                    valor: opcao.valor
                }));
                await api.put('/configuracoes-onde-conheceu', valoresAlterados);
            }

            Swal.fire('Sucesso', 'Opções salvas com sucesso!', 'success');
            onClose();
        } catch (error) {
            Swal.close();
            Swal.fire('Erro', `Erro ao salvar: ${error.response?.data?.message || error.message}`, 'error');
        }
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '600px' }}>
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">Onde Conheceu?</h4>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-12">
                                    <p className="text-muted mb-4">
                                        Configure as opções de como os clientes conheceram o estabelecimento.
                                        Estas opções aparecerão no cadastro de clientes.
                                    </p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <label className="form-label fw-bold mb-0">Opções</label>
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary"
                                            onClick={handleAdicionarOpcao}
                                        >
                                            <FaPlus className="me-2" />
                                            Adicionar Nova Opção
                                        </button>
                                    </div>
                                    <div className="row max-h-400 overflow-y-auto">
                                        {opcoes.map((opcao, index) => (
                                            <div key={index} className="d-flex align-items-center mt-3">
                                                <input
                                                    type="text"
                                                    className="form-control me-2"
                                                    placeholder={`Opção ${index + 1}`}
                                                    value={opcao.valor}
                                                    onChange={(e) => handleChange(index, e.target.value)}
                                                    autoComplete="off"
                                                />
                                                <button
                                                    type="button"
                                                    className="btn btn-danger"
                                                    onClick={() => handleRemoverOpcao(index)}
                                                    title={opcao.isNew ? "Remover opção" : "Excluir opção"}
                                                >
                                                    <FaTrash />
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div className="modal-footer">
                        <button className="btn btn-outline-danger" type="button" onClick={onClose}>
                            <FaTimes /> Fechar
                        </button>
                        <button className="btn btn-custom-primary" type="submit" onClick={handleSubmit}>
                            <FaRegSave /> Salvar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OndeConheceuModal; 